import React, { useEffect, useState } from 'react'

import Button from '../../components/ButtonNew'
import InputField from '../../components/InputField'

import ArrowRightIcon from '../../assets/icons/common/arrow-right.svg'
import FlowerImg from '../../assets/images/signup/flower.png'
import CallIcon from '../../assets/icons/call-icon.svg'
import EditIcon from '../../assets/icons/edit-icon.svg'
import Text from '../../components/Text'
import OTPInputField from '../../components/OTPInputField'
import UserProfileDetails from './UserProfileDetails'
import { showErrorToast } from '../../utils/toast'
import PageHeader from '../../components/Layout/Header/PageHeader'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/slices/index'
import { useNavigate, useLocation } from 'react-router-dom'
import { getUrlParams } from '../../utils/helpers/common'
import Spinner from '../../components/Spinner'
import { supportProgramTypes } from '../../constants/support-programs'
import constants from '../../constants'
import DiasensImage from '../../assets/images/diasens.webp'
import { TERMS_URL, POLICY_URL } from '../../constants'
import { getCgmTypeFromHostname } from '../../utils/helpers/cgmHostname'

const OTP_RESEND_TIME = 30

const SignupUser = ({ showFlower = true, showHeader = false }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const params = getUrlParams()

  const isCgmFlow = Boolean(params?.cgm) || location.state?.isCgmFlow
  const cgmType =
    params?.cgm ||
    (location.state?.isCgmFlow ? getCgmTypeFromHostname() : undefined)

  // Override props with navigation state if provided
  const finalShowHeader =
    location.state?.showHeader !== undefined
      ? location?.state?.showHeader
      : showHeader
  const finalShowFlower =
    location.state?.showFlower !== undefined
      ? location?.state?.showFlower
      : showFlower

  const [phoneNumber, setPhoneNumber] = useState('')
  const [activeScreen, setActiveScreen] = useState('phone')
  const [timer, setTimer] = useState(OTP_RESEND_TIME)
  const [otp, setOtp] = useState('')
  const [otpError, setOtpError] = useState(false)
  const { sendOtp, verifyOtp, updateProfile } = useSelector(
    (state) => state.auth,
  )
  const rightImage = location.state?.programLogo
  useEffect(() => {
    if (activeScreen === 'otp') {
      //Implementing the setInterval method
      const intervalRef = setInterval(() => {
        if (timer > 0) setTimer(timer - 1)
      }, 1000)

      //Clearing the interval
      return () => clearInterval(intervalRef)
    }
  }, [timer, activeScreen])

  useEffect(() => {
    if (verifyOtp?.data?.code === 0) {
      setOtpError(true)
    }
  }, [verifyOtp])
  const isAnayaCare =
    params?.support_program_type === constants.CARE_PROGRAM_TYPE.ANAYA

  const handleContinueClick = () => {
    localStorage.removeItem('auth_token')
    localStorage.setItem('phone_number', phoneNumber)
    if (phoneNumber.length === 10) {
      const payload = {
        payload: {
          contactNo: phoneNumber,
          otpType: 'LOGIN',
        },
        headers: {
          // Use CGM_USER_FROM for CGM flow, PSP_USER_FROM for PSP flow
          userFrom: isCgmFlow
            ? constants.CGM_USER_FROM
            : constants.PSP_USER_FROM,
          source: constants.GOOD_FLIP_SOURCE,
        },
      }
      if (isAnayaCare) {
        payload.headers.platform = 'app'
      }

      // For PSP flow, add support program metadata
      if (!isCgmFlow) {
        payload.payload.meta = {
          userFrom: constants.PSP_USER_FROM,
          source: constants.GOOD_FLIP_SOURCE,
          support_program_type:
            supportProgramTypes[params?.support_program_type]?.name,
        }
      } else {
        // For CGM flow, add minimal metadata
        payload.payload.meta = {
          userFrom: constants.CGM_USER_FROM,
          source: constants.GOOD_FLIP_SOURCE,
          cgm_type: cgmType,
        }
      }

      new Promise((resolve, reject) => {
        dispatch(
          actions.sendOtpRequest({
            payload,
            resolve,
            reject,
          }),
        )
      })
        .then((response) => {
          if (Number(response?.code || 0) === 1) {
            setActiveScreen('otp')
            setTimer(OTP_RESEND_TIME)
          } else {
            showErrorToast(response?.message)
          }
        })
        .catch((error) => {
          showErrorToast(error?.message)
        })
    }
  }

  const handleEditClick = () => {
    setActiveScreen('phone')
    setOtp('')
    setOtpError(false)
  }

  const handleOtpChange = (otp) => {
    setOtp(otp)
    setOtpError(false)

    if (otp.length === 6) {
      handleVerifyOtp(otp)
      // setActiveScreen('user-profile')
    }
  }

  const handleResendOtp = () => {
    setOtpError(false)
    setOtp('')
    handleContinueClick()
  }
  const navigateToAnayaCare = () => {
    navigate(
      `/care-plans/anaya-care/home?support_program_type=${params?.support_program_type}`,
    )
  }

  const handleCheckSourceAndProgram = async (authData) => {
    // Skip blocking for CGM flow - they are not PSP users
    if (isCgmFlow) {
      return false
    }

    const { patient_meta_info, user_from, is_plan_expired } = authData
    const supportProgramKey = isAnayaCare
      ? constants.CARE_PROGRAM_TYPE.ANAYA
      : patient_meta_info?.support_program_key
    const supportProgramType = patient_meta_info?.support_program_type
    const isPlanExpired = Boolean(is_plan_expired)
    // console.log({ isPlanExpired })

    // debugger
    // Block if not from PSP
    if (user_from !== constants.PSP_USER_FROM) {
      navigate(`/blocked?support_program_name=goodflip`)
      return true
    }

    // Block if support program key doesn't match or plan is not expired  || !isPlanExpired
    if (supportProgramKey !== params?.support_program_type) {
      navigate(`/blocked?support_program_name=${supportProgramType}`)
      return true
    }
    return false
  }

  const handleVerifyOtp = (otp) => {
    const payload = {
      payload: {
        contactNo: phoneNumber,
        otpType: 'LOGIN',
        otp: Number(otp),
      },
      headers: {
        // Use CGM_USER_FROM for CGM flow, PSP_USER_FROM for PSP flow
        userFrom: isCgmFlow ? constants.CGM_USER_FROM : constants.PSP_USER_FROM,
        source: constants.GOOD_FLIP_SOURCE,
      },
    }

    if (isAnayaCare) {
      payload.headers.platform = 'app'
    }

    // For PSP flow (not CGM), add patient meta info and medical condition
    if (!isCgmFlow && !isAnayaCare) {
      payload.payload.medical_condition_group_id =
        supportProgramTypes[params?.support_program_type]
          ?.medical_condition_group_id || null
      payload.payload.patient_meta_info = {
        support_program_type:
          supportProgramTypes[params?.support_program_type]?.name,
        support_program_key: params?.support_program_type,
      }
    }
    // For CGM flow, don't add patient_meta_info or medical_condition_group_id

    new Promise((resolve, reject) => {
      dispatch(
        actions.verifyOtpRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
      .then(async (res) => {
        if (Number(res?.code || 0) === 1) {
          if (isAnayaCare && !res?.data) {
            setActiveScreen('user-profile')
            return
          }
          // Add a check to see if the user is already registered (only for PSP)
          const isRegistered = await handleCheckSourceAndProgram(res?.data)
          if (isRegistered) {
            return
          }
          localStorage.setItem('auth_token', res?.data?.token)

          // Handle CGM flow
          if (isCgmFlow) {
            if (cgmType === constants.CGM_TYPE.GOODFLIP) {
              // Set device name for GoodFlip
              try {
                await new Promise((resolve, reject) => {
                  dispatch(
                    actions.setCgmDeviceNameRequest({
                      deviceName: 'goodflip',
                      resolve,
                      reject,
                    }),
                  )
                })
              } catch (error) {
                console.error('Error setting device name:', error)
                showErrorToast('Failed to set device. Please try again.')
                return
              }
              navigate(`/signup-success?cgm=${cgmType}`)
              return
            }
            // Both new and existing CGM users - navigate to success page
            setActiveScreen('user-profile')
            return
          }

          // Handle PSP flow
          if (res?.data?.newUser) {
            // For GOODFLIP PSP, skip onboarding and go directly to success page
            if (
              params?.support_program_type ===
              constants.CARE_PROGRAM_TYPE.GOODFLIP
            ) {
              navigate(
                `/psp/signup-success?support_program_type=${params?.support_program_type}`,
              )
            } else {
              setActiveScreen('user-profile')
            }
          } else {
            if (
              params?.support_program_type === constants.CARE_PROGRAM_TYPE.ANAYA
            ) {
              navigateToAnayaCare()
              return
            }
            navigate(
              `/psp/signup-success?support_program_type=${params?.support_program_type}`,
            )
          }
        } else {
          showErrorToast(res?.message)
        }
      })
      .catch((error) => {
        showErrorToast(error?.message)
      })
  }

  const handleFinish = (data) => {
    const payload = {
      payload: {
        ...data,
        register: true,
        contact_no: phoneNumber,
      },
      headers: {
        // Use CGM_USER_FROM for CGM flow, PSP_USER_FROM for PSP flow
        userFrom: isCgmFlow ? constants.CGM_USER_FROM : constants.PSP_USER_FROM,
        source: constants.GOOD_FLIP_SOURCE,
      },
    }

    // For PSP flow (not CGM), add medical condition and patient meta info
    if (!isCgmFlow) {
      payload.payload.medical_condition_group_id =
        supportProgramTypes[params?.support_program_type]
          ?.medical_condition_group_id || null
      payload.payload.patient_meta_info = {
        support_program_type:
          supportProgramTypes[params?.support_program_type]?.name,
        ...(params?.support_program_type !==
          constants.CARE_PROGRAM_TYPE.ANAYA && {
          support_program_key: params?.support_program_type,
        }),
      }
    }
    // For CGM flow, don't add patient_meta_info or medical_condition_group_id
    // For CGM flow, set city and state as empty strings
    if (isCgmFlow) {
      payload.payload.city = ''
      payload.payload.state = ''
    }

    new Promise((resolve, reject) => {
      dispatch(
        actions.updateProfileRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
      .then(async (res) => {
        if (Number(res?.code || 0) === 1) {
          // Handle CGM flow
          if (isCgmFlow) {
            navigate(`/signup-success?cgm=${cgmType}`)
            return
          }

          // Handle PSP flow
          if (
            [
              constants.CARE_PROGRAM_TYPE.ANAYA,
              constants.CARE_PROGRAM_TYPE.NIVOLUMAB,
            ].includes(params?.support_program_type)
          ) {
            navigateToAnayaCare()
          } else {
            navigate(
              `/psp/signup-success?support_program_type=${params?.support_program_type}`,
            )
          }
        } else {
          showErrorToast(res?.message)
        }
      })
      .catch((error) => {
        showErrorToast(error?.message)
      })
  }

  if (!params?.support_program_type && !params?.cgm && !isCgmFlow) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Text variant="body" size="large" tag="h2" className="text-red-600">
          Invalid program type
        </Text>
      </div>
    )
  }

  if (activeScreen === 'user-profile') {
    return (
      <UserProfileDetails
        onFinish={handleFinish}
        loading={updateProfile.loading}
      />
    )
  }

  if (activeScreen === 'otp') {
    return (
      <div className="min-w-sm max-w-lg pb-[98px] relative mx-auto w-full overflow-hidden">
        {finalShowHeader && (
          <PageHeader
            handleOnBack={() => navigate(-1)}
            pageTitle="Back"
            withBackBtn={true}
            rightImage={rightImage || null}
          />
        )}
        {finalShowFlower && (
          <img
            src={FlowerImg}
            alt="flower"
            className="w-[160px] h-[160px] absolute -z-10 top-0 right-0 -mr-[2px]"
          />
        )}
        <div className={`z-10 px-4 ${finalShowHeader ? 'pt-6' : 'pt-12'}`}>
          <Text
            variant="display"
            size="small"
            className="text-[#101828] mb-3"
            tag="h2"
          >
            Enter OTP
          </Text>
          <Text
            variant="body"
            size="large"
            className="text-[#344054] mb-8"
            tag="p"
          >
            An OTP is sent to the following number
          </Text>
          <div className="flex items-center gap-1 text-base font-medium text-[#101828]">
            <img src={CallIcon} alt="call-icon" className="w-6 h-6" />
            <p>+91 {phoneNumber}</p>
            <button
              className="ml-2 text-[#299D6B] flex items-center gap-1"
              onClick={handleEditClick}
            >
              Edit <img src={EditIcon} alt="edit-icon" />
            </button>
          </div>

          {/* {renderOTPInput()} */}
          <OTPInputField
            label="Secure Code"
            value={otp}
            onChange={handleOtpChange}
            className="mt-6"
            error={otpError}
            helperText={otpError ? 'Invalid OTP' : ''}
          />

          <div className="flex items-center gap-2 mt-6">
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-[#667085]"
            >
              Didn't receive the OTP?
            </Text>
            {sendOtp?.loading ? (
              <div className="flex items-center gap-2">
                <Text
                  variant="body"
                  size="medium"
                  tag="p"
                  className="text-[#667085]"
                >
                  Resending OTP
                </Text>
                <Spinner />
              </div>
            ) : timer > 0 ? (
              <Text
                variant="body"
                size="medium"
                tag="p"
                className="text-[#667085]"
              >
                Resend OTP in 00:{timer < 10 ? `0${timer}` : timer}
              </Text>
            ) : (
              <button onClick={handleResendOtp}>
                <Text
                  variant="body"
                  size="medium"
                  tag="p"
                  className="text-[#299D6B] font-medium"
                >
                  Resend OTP
                </Text>
              </button>
            )}
          </div>

          {verifyOtp?.loading && (
            <div className="flex items-center gap-2 mt-6">
              <Text
                variant="body"
                size="medium"
                tag="p"
                className="text-[#667085]"
              >
                Verifying OTP
              </Text>
              <Spinner />
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="min-w-sm max-w-lg pb-[98px] relative mx-auto w-full overflow-hidden">
      {finalShowHeader && (
        <PageHeader
          handleOnBack={() => navigate(-1)}
          pageTitle="Back"
          withBackBtn={true}
          rightImage={rightImage || null}
        />
      )}
      {finalShowFlower && (
        <img
          src={FlowerImg}
          alt="flower"
          className="w-[160px] h-[160px] absolute -z-10 top-0 right-0 -mr-[2px]"
        />
      )}
      <div className={`z-10 px-4 ${finalShowHeader ? 'pt-6' : 'pt-12'}`}>
        <Text
          variant="headline"
          size="small"
          className="text-[#101828] mb-3"
          tag="h2"
        >
          Enter Mobile Number
        </Text>
        <Text
          variant="body"
          size="large"
          className="text-[#344054] mb-8"
          tag="p"
        >
          An OTP will be sent to the following number for verification
        </Text>

        {/* <InputNew label="Mobile Number" /> */}
        <InputField
          label="Mobile Number"
          type="tel"
          maxLength={10}
          leftIcon={<img src={CallIcon} alt="ph" className="h-6 w-6" />}
          // prefix="+91"
          placeholder="Enter your mobile number"
          value={phoneNumber}
          autoFocus
          onChange={(event) => {
            if (/^\d{0,10}$/.test(event.target.value)) {
              setPhoneNumber(event.target.value)
            }
          }}
        />

        <Text
          variant="body"
          size="small"
          className="text-[#667085] mt-4"
          tag="p"
        >
          By signing up you agree to GoodFlip's{' '}
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold underline"
          >
            Terms and Conditions
          </a>{' '}
          and{' '}
          <a
            href={POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold underline"
          >
            Privacy Policy
          </a>
        </Text>
      </div>

      <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full">
        <Button
          fullWidth
          onClick={handleContinueClick}
          loading={
            sendOtp.loading || verifyOtp.loading || updateProfile.loading
          }
          disabled={
            phoneNumber.length !== 10 ||
            sendOtp.loading ||
            verifyOtp.loading ||
            updateProfile.loading
          }
        >
          Continue <img src={ArrowRightIcon} />
        </Button>
      </div>
    </div>
  )
}

export default SignupUser
